<template>
  <div class="monitoring-cabin-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="clickAdd" title="新增" size="mini"
                     type="primary" icon="el-icon-plus">新增
          </el-button>
          <el-button @click="clickEdit" title="编辑" size="mini"
                     type="primary" icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="del" size="mini"
                     type="primary" icon="el-icon-delete">删除
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="总段名称"></el-table-column>
        <el-table-column label="总段编号">123</el-table-column>
      </el-table>
    </div>

    <div class="pagination pt-10 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                     :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                     :current-page.sync="pagination.page" :total="pagination.total" @size-change="changeSize"
                     @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">总段名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">总段编号</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置基站" width="800px" :visible.sync="authDialogShow">
      <div class="mb-20">
        <span>已选择{{hasBaseStationIds.length}}个基站：</span>
        <span class="mr-10"
              v-for="(item,index) in allBaseStations"
              :key="index" v-if="hasBaseStationIds.indexOf(item.id)>-1">
          <el-button size="mini">{{item.name}}</el-button></span>
      </div>
      <div class="auth-box">
        <div class="item" :class="item.active?'active':''" @click="setActive(index)"
             v-for="(item,index) in allBaseStations" :key="index">
          <span class="zsf-icon check"
                :class="hasBaseStationIds.indexOf(item.id)>-1?'zsf-icon-yixuanze- color-409eff':'zsf-icon-weixuanze-1 color-dcdcdc'"></span>
          <span class="width-100 t-hidden">{{item.id}}</span>
          <span class="width-150 color-999 ml-10">{{item.name}}</span>
          <span class="color-999 ml-10">其他字段</span>
        </div>
      </div>
      <div class="pagination pt-10 t-center mt-10">
        <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                       :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                       :current-page.sync="pagination.page"
                       :total="pagination.total"
                       @size-change="changeSize"
                       @current-change="changeCurrent"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="authDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitAuth">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {api} from '../../common/js/api.js';
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: ""},
        addDialogShow: false,
        authDialogShow: false,
        hasBaseStationIds: [1, 2, 8],
        allBaseStations: []
      };
    },

    computed: {},

    created() {
      this.getData();
    },

    methods: {
      submitAuth(){
      },
      showAuthDialog() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.authDialogShow = true;
      },
      setActive(index) {
        console.log(this.allBaseStations[index].id);
        let id = this.allBaseStations[index].id;
        let hasBaseStationIds = [...this.hasBaseStationIds];
        let isHas = hasBaseStationIds.indexOf(id);
        if (isHas > -1) {
          hasBaseStationIds.splice(index, 1);
        } else {
          hasBaseStationIds.push(id);
        }
        this.hasBaseStationIds = hasBaseStationIds;
        console.log(this.hasBaseStationIds);
      },

      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },
      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },
      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },
      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        this.tableLoading = false;
        this.pagination.total = 222;
        let list = [];
        for (let i = 1; i < 11; i++) {
          list.push({id: i, name: '基站' + i});
        }
        this.list = list;
        this.allBaseStations = list;
      },
      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .monitoring-cabin-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .auth-box {
      font-size: 13px;
      height: 400px;
      overflow-y: auto;
      border-top: 1px solid #dcdcdc;
      .item {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        border-bottom: 1px solid #dcdcdc;
        span {
          height: 45px;
          line-height: 45px;
          display: block;
          float: left;
        }
        &.active {
          background: #f9f9f9;
        }
        .check {
          display: inline-block;
          width: 30px;
        }
        .color-409eff {
          color: #409eff;
        }
        .color-dcdcdc {
          color: #dcdcdc;
        }
      }
    }
  }
</style>
